var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAviso(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.9985C22 6.47569 17.5228 1.99854 12 1.99854C6.47715 1.99854 2 6.47569 2 11.9985C2 13.6413 2.3972 15.2279 3.1449 16.6488L2.02855 20.9372C1.99198 21.0776 1.99199 21.2251 2.02858 21.3656C2.1469 21.8199 2.6111 22.0922 3.06538 21.9739L7.35578 20.8568C8.77516 21.6025 10.3596 21.9985 12 21.9985C17.5228 21.9985 22 17.5214 22 11.9985ZM12 6.5C12.4142 6.5 12.75 6.83579 12.75 7.25V13.5C12.75 13.9142 12.4142 14.25 12 14.25C11.5858 14.25 11.25 13.9142 11.25 13.5V7.25C11.25 6.83579 11.5858 6.5 12 6.5ZM13 16.4979C13 17.0501 12.5523 17.4979 12 17.4979C11.4477 17.4979 11 17.0501 11 16.4979C11 15.9456 11.4477 15.4979 12 15.4979C12.5523 15.4979 13 15.9456 13 16.4979Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviso);
export default __webpack_public_path__ + "static/media/aviso.a55982e5bbb66fe90a7e29dfde341596.svg";
export { ForwardRef as ReactComponent };